/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Evgenij Tyan
 * @version 1.1.0
 * @since 1.0.0
 */

import { select, takeEvery } from 'redux-saga/effects';

import { stringFormat } from '../../utils/stringFormat';
import { API_HOSTNAME } from '../app/Api';
import { START_EXPORT } from './exportConstants';
import { getDataForExport } from './exportSelectors';
import { IStartExport } from './exportTypes';

export function* startExportSaga({ payload }: IStartExport) {
    try {
        const { fileFormat } = yield select(getDataForExport());
        const url = `${API_HOSTNAME}${stringFormat(payload, fileFormat)}`;
        window.open(url, '_blank');
    } catch (e) {
        console.error(e);
    }
}

export function* exportSagas() {
    yield takeEvery(START_EXPORT, startExportSaga);
}
